import { useSecondLookIntegration } from '@servicetitan/financing-workflow-shared';
import { FinturfDisclosureText } from './FinturfDisclosureText';
import { TurnsDisclosureText } from './TurnsDisclosureText';

/**
 * Renders the disclosure body for the tenant's configured second-look provider.
 * Used in content drawers (e.g. Wells Fargo "View terms"). For inline co-application
 * checkboxes, prefer {@link FinturfDisclosureText} / {@link SecondLookCoapplicationDisclosure}.
 */
export const SecondLookDisclosureText = () => {
    const { secondLookProvider } = useSecondLookIntegration();
    const normalizedProvider = secondLookProvider?.toLowerCase();

    if (normalizedProvider === 'finturf') {
        return <FinturfDisclosureText />;
    }

    if (normalizedProvider === 'turns') {
        return <TurnsDisclosureText />;
    }

    return null;
};
